import React from 'react';
import { Done } from '@lt/components/icons-react';
import classnames from 'classnames';
import styles from './passwordHint.module.css';

export interface HintItem {
  name: string;
  checked: boolean;
}

interface Props {
  className?: string;
  items: HintItem[];
}

export const PasswordHint: React.FC<Props> = ({ items, className }) => (
  <div className={classnames(styles.container, className)}>
    {items.map((item) => (
      <div className={styles.item} key={item.name}>
        {item.checked && <Done width={16} />}
        <span
          className={classnames(styles.itemText, {
            [styles.itemTextActive]: item.checked,
            [styles.itemTextNotActive]: !item.checked,
          })}
        >
          {item.name}
        </span>
      </div>
    ))}
  </div>
);
